module.exports = __webpack_public_path__ + "assets/img/icon_user13.957b02a6.png";